var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCornerCircleWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_898_22332",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 244,
    height: 212
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 212,
    width: 244,
    height: 212,
    transform: "rotate(-180 244 212)",
    fill: "#D9D9D9",
    fillOpacity: 0.75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_898_22332)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -11.3114,
    cy: 239.689,
    r: 227.5,
    transform: "rotate(-20.6112 -11.3114 239.689)",
    stroke: "url(#paint0_linear_898_22332)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -11.3114,
    cy: 239.689,
    r: 191.89,
    transform: "rotate(-20.6112 -11.3114 239.689)",
    stroke: "url(#paint1_linear_898_22332)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -10.5469,
    cy: 240.035,
    r: 156.873,
    transform: "rotate(-20.6112 -10.5469 240.035)",
    stroke: "url(#paint2_linear_898_22332)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -10.5469,
    cy: 240.035,
    r: 121.262,
    transform: "rotate(-20.6112 -10.5469 240.035)",
    stroke: "url(#paint3_linear_898_22332)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -11.3114,
    cy: 239.689,
    r: 83.8714,
    transform: "rotate(-20.6112 -11.3114 239.689)",
    stroke: "url(#paint4_linear_898_22332)",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_898_22332",
    x1: -11.3114,
    y1: 11.1886,
    x2: -11.3114,
    y2: 468.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7376FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66DDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_898_22332",
    x1: -11.3114,
    y1: 46.7989,
    x2: -11.3114,
    y2: 432.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7376FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66DDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_898_22332",
    x1: -10.5469,
    y1: 82.1624,
    x2: -10.5469,
    y2: 397.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7376FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66DDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_898_22332",
    x1: -10.5469,
    y1: 117.773,
    x2: -10.5469,
    y2: 362.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7376FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66DDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_898_22332",
    x1: -11.3114,
    y1: 154.817,
    x2: -11.3114,
    y2: 324.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7376FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66DDD7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerCircleWaves);
export default __webpack_public_path__ + "static/media/cornerCircleWaves.8e6a72f67cbf4055a574320215f54bfe.svg";
export { ForwardRef as ReactComponent };